import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useMemo, useRef } from "react";
import mitt from "mitt";
import { VelavuEventStream } from "velavu-js-api";
const StreamContext = createContext({
    get events() {
        throw new Error("No stream context is available!");
    }
});
/**
 * A provider that manages a Velavu event stream
 */
export function VelavuStreamContextProvider({ configProvider, children }) {
    const eventEmitter = useRef(mitt()).current;
    useEffect(() => {
        //Don't do anything if no config provider is provided
        if (configProvider === undefined) {
            return;
        }
        //Create the event stream
        const stream = new VelavuEventStream(configProvider);
        //Forward all events to the event emitter
        stream.events.on("*", (type, event) => {
            eventEmitter.emit(type, event);
        });
        //Start the event stream
        stream.start();
        //Stop the event stream on unmount
        return () => {
            stream.stop();
        };
    }, [eventEmitter, configProvider]);
    const contextValue = useMemo(() => ({
        events: eventEmitter
    }), [eventEmitter]);
    return (_jsx(StreamContext.Provider, { value: contextValue, children: children }));
}
export function useVelavuStream(key, handler) {
    const streamContext = useContext(StreamContext);
    useEffect(() => {
        streamContext.events.on(key, handler);
        return () => {
            streamContext.events.off(key, handler);
        };
    }, [streamContext, key, handler]);
}
//# sourceMappingURL=StreamContext.js.map